import React, { useContext } from "react";
import ShoppingCartProductContext from "./ShoppingCartProductContext";
import { API_URL_IMAGE_ITEM } from "../../api/URL/constants";

const ShoppingCartProduct = ({ product }) => {
  const { removeFromCart, increase, decrease } = useContext(
    ShoppingCartProductContext
  );

  return (
    <li key={product.id} className="flex py-6">
      <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
        {process.env.REACT_APP_DEV === "true" ? (
          <img
            src={product.image}
            alt="product image"
            className="h-full w-full object-cover object-center"
          />
        ) : (
          <img
            src={API_URL_IMAGE_ITEM + product.image}
            alt="product image"
            className="h-full w-full object-cover object-center"
          />
        )}
      </div>

      <div className="ml-4 flex flex-1 flex-col">
        <div>
          <div className="flex justify-between text-base font-medium text-gray-900">
            <h3>{product.name}</h3>
            {product.discount !== null ? (
              <div>
                <p className="ml-4 line-through text-gray-500">
                  ${product.price}
                </p>
                <p className="ml-4">
                  $
                  {(((100 - product.discount) / 100) * product.price).toFixed(
                    2
                  )}
                  $
                </p>
              </div>
            ) : (
              <div>
                <p className="ml-4">${product.price}</p>
              </div>
            )}
          </div>
        </div>
        <div className="flex justify-between">
          <div className="flex items-center space-x-2 mt-3">
            <div
              className="w-6 h-6 rounded-full flex items-center justify-center"
              style={{
                backgroundColor: "#" + product.color,
                opacity: "75%",
                borderWidth: 1,
                borderColor: "black",
              }}
            ></div>

            <div className="w-5 h-5 border border-black flex items-center justify-center">
              <span className="text-black text-xs">{product.size}</span>
            </div>
          </div>

          <div className="flex items-center">
            {product.quantity > 1 ? (
              <button
                type="button"
                onClick={() => decrease(product)}
                className="text-gray-500"
              >
                -
              </button>
            ) : (
              <button type="button" disabled className="text-gray-500">
                -
              </button>
            )}
            <p className="mx-2">{product.quantity}</p>
            <button
              type="button"
              // onClick={() => increase(product)}
              onClick={() =>
                product.quantity_in_stock > product.quantity
                  ? increase(product)
                  : null
              }
              className="text-gray-500"
            >
              +
            </button>
          </div>
          {/* <div className="flex items-center">
            {product.quantity > 1 ? (
              <button
                type="button"
                onClick={() => decrease(product)}
                className="text-gray-500 border w-8 h-8 border-black  p-1"
              >
                -
              </button>
            ) : (
              <button
                type="button"
                disabled
                className="text-gray-500 border w-8 h-8 border-black  p-1"
              >
                -
              </button>
            )}
            <p className="border border-black w-8 h-8 flex items-center justify-center">
              <span>{product.quantity}</span>
            </p>
            <button
              type="button"
              onClick={() => increase(product)}
              className="text-gray-500 border w-8 h-8 border-black  p-1"
            >
              +
            </button>
          </div> */}
        </div>
        <div className="flex flex-1 items-end justify-between text-sm">
          <p></p>
          {/* <div className="flex items-center">
            {product.quantity > 1 ? (
              <button
                type="button"
                onClick={() => decrease(product)}
                className="text-gray-500"
              >
                -
              </button>
            ) : (
              <button type="button" disabled className="text-gray-500">
                -
              </button>
            )}
            <p className="mx-2">{product.quantity}</p>
            <button
              type="button"
              onClick={() => increase(product)}
              className="text-gray-500"
            >
              +
            </button>
          </div> */}

          <div className="flex">
            <button
              type="button"
              onClick={() => removeFromCart(product)}
              className="font-medium text-indigo-600 hover:text-indigo-500"
            >
              Remove
            </button>
          </div>
        </div>
      </div>
    </li>
  );
};

export default ShoppingCartProduct;
